import { render, staticRenderFns } from "./Siderbar.vue?vue&type=template&id=3e85e182&scoped=true"
import script from "./Siderbar.vue?vue&type=script&lang=js"
export * from "./Siderbar.vue?vue&type=script&lang=js"
import style0 from "./Siderbar.vue?vue&type=style&index=0&id=3e85e182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85e182",
  null
  
)

export default component.exports